import { createFileRoute } from "@tanstack/react-router";

import { SignInPage } from "../components/auth/SignInPage";

export interface SignInSearch {
  /** Set after a password reset, which ended every session of the account. */
  passwordChanged?: boolean;
}

/**
 * Dovod-account sign-in. This route is never gated (redirected away) by
 * `context.authGateState`; it only reads it for `legacyStateNotice`,
 * rendered as an informational notice on the sign-in surface.
 */
export const Route = createFileRoute("/sign-in")({
  validateSearch: (search: Record<string, unknown>): SignInSearch => ({
    passwordChanged: search.passwordChanged === true ? true : undefined,
  }),
  component: SignInRouteComponent,
});

function SignInRouteComponent() {
  const { authGateState } = Route.useRouteContext();
  const { passwordChanged } = Route.useSearch();
  const legacyStateNotice =
    authGateState.status === "requires-auth" ? authGateState.auth?.legacyStateNotice : undefined;

  return (
    <SignInPage legacyStateNotice={legacyStateNotice} passwordChanged={passwordChanged === true} />
  );
}
